import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Col, Container, Modal, Row } from "reactstrap";

const Section = () => {

  return (
    <React.Fragment>
      <section className="bg-home-2 align-items-center d-flex" id="home">
        <Container>
          <Row className="justify-content-center">
            <Col lg={12}>
              <div className="text-center">
                <h1 className="display-5 fw-normal fw-bold">
                  Matrix Vision Technologies
                </h1>
                <p className="mt-4 fw-bold">
                  Industrial Machine Vision & Automation Consultancy
                </p>

                <p className="home-desc text-muted mt-4">
                  Expert solutions in Machine Vision, LabVIEW automation, and application-specific smart camera systems to improve quality, speed, and productivity in manufacturing.
                </p>

                <div className="mt-4">
                  <a href="#contact" className="btn btn-primary btn-round me-3 mt-4">
                    Free Consultation
                  </a>
                  <a href="#services" className="btn btn-blue btn-round mt-4">
                    Our Services
                  </a>
                </div>

              </div>
            </Col>
          </Row>
        </Container>

      </section>
    </React.Fragment>
  );
};

export default Section;
